import { Routes } from '@angular/router';

// The application is rendered as one authenticated shell. These componentless
// routes let Angular own and recognize the browser URLs while App selects the
// corresponding shell view from window.location.
export const routes: Routes = [
  { path: '', pathMatch: 'full', children: [] },
  { path: 'monitors', children: [] },
  { path: 'monitors/:monitorId', children: [] },
  { path: 'team', children: [] },
  { path: '**', redirectTo: '' },
];
